import { PathsEnum } from '@routes/enumerators/paths.enum';

const titleByLocationList: any = {
	[PathsEnum.COLABORADOR]: 'Colaborador',
	[PathsEnum.HOLERITE]: 'Holerite',
	[PathsEnum.BANCODEHORAS]: 'Banco de horas',
	[PathsEnum.INFORMERENDIMENTOS]: 'Informe de rendimentos',
	[PathsEnum.PERFORMANCE_PRODUTO]: 'Performance de produto',
	[PathsEnum.VAREJO_PRODUTO_IMAGEM]: 'Busca por Imagem',
};

export const getHeaderTitle = (pathname: PathsEnum) => {
	if (titleByLocationList[pathname]) {
		return titleByLocationList[pathname];
	}
	return 'Colaborador';
};
